import { QRCodeSVG } from "qrcode.react";
import type React from "react";
import type { Except } from "type-fest";

export const FullSizeQRCode: React.FC<
  Except<React.ComponentProps<typeof QRCodeSVG>, "className">
> = (props) => {
  return (
    <div className="absolute inset-0 m-auto aspect-square max-h-full max-w-full bg-white p-6 md:p-8">
      <QRCodeSVG className="size-full" {...props} />
    </div>
  );
};
